export const formatFileSize = (sizeInBytes: number): string => {
	const sizes: string[] = ["bytes", "kb", "mb", "gb"];
	const i: number = Math.floor(Math.log(sizeInBytes) / Math.log(1024));
	return parseFloat((sizeInBytes / Math.pow(1024, i)).toFixed(2)) + " " + sizes[i];
};
